import http from './http' // needs this file in the same directory
import {The_Ability} from '../store/index'

export default {
  index(filter){
    return http.get(`/forms`, {params: {...filter}});
  },
  indexLean(filter){
    return http.get(`/forms_lean`, {params: {...filter}});
  },

  indexDeleted(filter) {
    return http.get(`/forms_deleted`, {params: {...filter}});
  },

  show(item_id){
    return http.get(`/forms/`+item_id);
  },

  showPdf(item_id){
    return http.get(`/forms/`+item_id+'.pdf');
  },

  createWithAi(form){
    return http.post(`/forms`, { form: { ...form } } )
  },

  create(new_item){
    if (The_Ability.can('create', 'Form')){
      return http.post(`/forms`,{
        form:{ 
          name: new_item.name,
          description: new_item.description,
          settings: new_item.settings,
          department_id: new_item.department_id,
          other_department_ids: new_item.other_department_ids,
          solution_id: new_item.solution_id,

          // items_attributes: new_item.items_attributes,
          item_setups_attributes: new_item.item_setups_attributes,
          custom_email_attributes: new_item.custom_email_attributes,
          approval_group_ids: new_item.approval_group_ids
        }
      });
    } else {
      return false
    }
  },

  update(update_item){
    // console.log({update_item, ab: The_Ability.can('update', 'Form')});
    // if (The_Ability.can('update', 'Form')){
      return http.put(`/forms/${update_item.id}`,{
        form:{ 
          id: update_item.id,

          name: update_item.name,
          description: update_item.description,
          settings: update_item.settings,
          department_id: update_item.department_id,
          other_department_ids: update_item.other_department_ids,
          solution_id: update_item.solution_id,

          // items_attributes: update_item.items_attributes,
          item_setups_attributes: update_item.item_setups_attributes,
          custom_email_attributes: update_item.custom_email_attributes,
          approval_group_ids: update_item.approval_group_ids
        }
      });
    // } else {
      // return false
    // }
  },

  delete(update_item){
    return http.delete(`/forms/${update_item}`);
  },

  deleteMany(form_ids){
    return http.post(`/delete_many_forms`, {ids: form_ids});
  },

  duplicate(form){
    return http.post(`/forms/${form.id}/duplicate`, {...form});
  },

  restore(form_id) {
    return http.post(`/restore_form/${form_id}`);
  }
}